import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux';
import ChatScreen from './functionalGiftedWebChat'
import { PageHeader } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom'
import PageDataLoader from 'components/pageDataLoader';
import { setNewChats } from 'actions/adminCare';

function StudentChat({ setNewChats }) {

    const [pageLoader, togglePageLoader] = useState(false)

    const history = useHistory();
    useEffect(() => {
        setNewChats([])
    })
    const goBack = () => {
        setNewChats([])
        history.goBack()
    }


    return (
        <div style={{
            height: "100%",
            width: "100%",
            backgroundColor: "#ffffff",
            borderRadius: "24px",
            boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.05)",
            border: "1px solid #E6E6E6",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column"
        }}>
            <div style={{
                display: "flex",
                height: "72px",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "#E6E6E6 solid 1px",
                padding: "0 20px",
                backgroundColor: "#ffffff"
            }}>
                <PageHeader
                    title={<div className="text-md" style={{ fontFamily: "roboto", fontWeight: "bold" }}>Chat</div>}
                    onBack={() => goBack()}
                    backIcon={<ArrowLeftOutlined style={{ fontSize: "20px", color: 'black' }} />}
                    style={{ padding: 0 }}
                />
            </div>
            <div style={{ width: "100%", height: "calc(100% - 72px)" }}>
                <ChatScreen studentChat={true} togglePageLoader={togglePageLoader} isAulasChat={true} />
                <PageDataLoader visible={pageLoader} />
            </div>
        </div>
    )
}

const mapDispatchToProps = dispatch => ({
    setNewChats: (chats) => dispatch(setNewChats(chats))
});


export default connect(null, mapDispatchToProps)(StudentChat);